module.exports = __webpack_public_path__ + "static/media/mapuM42.28392eab.webp";